import React from 'react';
import { useTranslation } from 'react-i18next';
import { Server, Shield, HardDrive, Mail } from 'lucide-react';
import { PricingCard } from '../components/PricingCard';

export function WebHostingPage() {
  const { t } = useTranslation();

  const hostingLinks = {
    starter1: 'https://my.synthohosting.net/index.php?rp=/store/webhosting/starter-1',
    starter2: 'https://my.synthohosting.net/index.php?rp=/store/webhosting/starter-2',
    starter3: 'https://my.synthohosting.net/index.php?rp=/store/webhosting/starter-3',

    advanced1: 'https://my.synthohosting.net/index.php?rp=/store/webhosting/advanced-1',
    advanced2: 'https://my.synthohosting.net/index.php?rp=/store/webhosting/advanced-2',
    advanced3: 'https://my.synthohosting.net/index.php?rp=/store/webhosting/advanced-3'
  };

  return (
    <div className="pt-16">

      {/* HERO */}
      <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">
            {t('webHosting.title')}
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            {t('webHosting.description')}
          </p>
        </div>
      </div>

      {/* FEATURES GRID */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Server className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('webHosting.features.performance.title')}
            </h3>
            <p className="text-gray-600">
              {t('webHosting.features.performance.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Shield className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('webHosting.features.security.title')}
            </h3>
            <p className="text-gray-600">
              {t('webHosting.features.security.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <HardDrive className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('webHosting.features.backup.title')}
            </h3>
            <p className="text-gray-600">
              {t('webHosting.features.backup.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Mail className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('webHosting.features.support.title')}
            </h3>
            <p className="text-gray-600">
              {t('webHosting.features.support.description')}
            </p>
          </div>
        </div>

        {/* PLANS */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <PricingCard
            title={t('webHosting.plans.starter1.title')}
            price={t('webHosting.plans.starter1.price')}
            specs={t('webHosting.plans.starter1.specs', { returnObjects: true })}
            buyLink={hostingLinks.starter1}
          />

          <PricingCard
            title={t('webHosting.plans.starter2.title')}
            price={t('webHosting.plans.starter2.price')}
            specs={t('webHosting.plans.starter2.specs', { returnObjects: true })}
            buyLink={hostingLinks.starter2}
          />

          <PricingCard
            title={t('webHosting.plans.starter3.title')}
            price={t('webHosting.plans.starter3.price')}
            specs={t('webHosting.plans.starter3.specs', { returnObjects: true })}
            buyLink={hostingLinks.starter3}
          />
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <PricingCard
            title={t('webHosting.plans.advanced1.title')}
            price={t('webHosting.plans.advanced1.price')}
            specs={t('webHosting.plans.advanced1.specs', { returnObjects: true })}
            buyLink={hostingLinks.advanced1}
            isPopular={true}
          />

          <PricingCard
            title={t('webHosting.plans.advanced2.title')}
            price={t('webHosting.plans.advanced2.price')}
            specs={t('webHosting.plans.advanced2.specs', { returnObjects: true })}
            buyLink={hostingLinks.advanced2}
          />

          <PricingCard
            title={t('webHosting.plans.advanced3.title')}
            price={t('webHosting.plans.advanced3.price')}
            specs={t('webHosting.plans.advanced3.specs', { returnObjects: true })}
            buyLink={hostingLinks.advanced3}
          />
        </div>

      </div>
    </div>
  );
}
